import { Component, Injector, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { AbstractField } from '../../models/field-configs/abstract-field';
import { FieldInputRadioConfig } from './models/field-input-radio-config.interface';
import { InputRadioOptionI } from './models/input-radio-option-i';
import { InputRadioOptionLoaderI } from './models/input-radio-option-loader-i';
import { _safe } from '@ordersnproducts/modules/shared/utils/safe-get.method';

@Component({
  selector: 'form-input-radio',
  styleUrls: ['form-input-radio.component.scss'],
  templateUrl: 'form-input-radio.component.html',
})
export class FormInputRadioComponent extends AbstractField implements OnInit, OnDestroy {
  config: FieldInputRadioConfig;
  group: UntypedFormGroup;
  options: InputRadioOptionI[];
  private _ngDestroyed = new Subject();
  public fieldControl: UntypedFormControl;
  public isRequired = false;
  private optionsLoader: InputRadioOptionLoaderI;
  public showInline = false;

  constructor(private injector: Injector) {
    super();
  }

  ngOnInit(): void {
    this.options = this.config.options;
    this.fieldControl = this.getControl() as UntypedFormControl;

    // Custom loader so you don't have to create new component
    // each time you want to preload options from API
    if (this.config.optionsLoader !== undefined) {
      this.optionsLoader = this.injector.get<InputRadioOptionLoaderI>(this.config.optionsLoader);

      this.optionsLoader
        .loadOptions(this.group)
        .pipe(takeUntil(this._ngDestroyed))
        .subscribe((options) => {
          if (options && options.length) {
            this.options = options;
          }
        });
    }

    this.isRequired = this.hasRequiredField(this.fieldControl);
    this.showInline = this.config.showInline && !!this.config.showInline;
  }

  changeRadio(optionId: string) {
    this.fieldControl.setValue(optionId);
  }

  ngOnDestroy(): void {
    this._ngDestroyed.next();
    this._ngDestroyed.complete();
  }
}
